import { render, staticRenderFns } from "./MainIndex.vue?vue&type=template&id=3638e2a5&scoped=true&"
import script from "./MainIndex.vue?vue&type=script&lang=js&"
export * from "./MainIndex.vue?vue&type=script&lang=js&"
import style0 from "./MainIndex.vue?vue&type=style&index=0&id=3638e2a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3638e2a5",
  null
  
)

export default component.exports